import React, { /* useContext, */ useState, useEffect, useRef } from "react";
import { COLOUR_HEX_TO_COLOUR_NAME, COLOUR_NAME_TO_COLOUR_HEX, GET_COLOUR_INDEX_FROM_COLOUR_NAME, IS_COLOUR_NAME, UPDATE_RECENT_COLOURS } from "../../../../helpers/Colours";
import { HexColorPicker } from "react-colorful";
import FormField from "../../../../components/forms/FormField/FormField";

import "./ColourPickerContent.scss";
import EditColourPalletteContent from "./EditColourPallette";
import { IconJsxer } from "../../../../helpers/IconHelper";
import { slideOutPanelControl } from "../SlideoutPanel";
// import EditCampaignColoursPopUpContent from "../../../../components/forms/ColorPicker/EditCampaignColoursPopUpContent";

const ColourPickerContent = (props) => {
    const [busy, setBusy] = useState(false);
    const [colourHasChangedNotApplied, setColourHasChangedNotApplied] = useState(false);
    const isDraggingRef = useRef(false);

    /* const [campaignData, setCampaignData] = useState(props.campaignData ? props.campaignData : null);
    useEffect(() => {
        setCampaignData(props.campaignData ? props.campaignData : null);
    }, [props.campaignData]); */

    const [currentVal, setCurrentVal] = useState(props.colour ? (COLOUR_HEX_TO_COLOUR_NAME(props.colour, props.campaignData) ? COLOUR_HEX_TO_COLOUR_NAME(props.colour, props.campaignData) : props.colour) : null);
    const currentValRef = useRef(currentVal);
    useEffect(() => {
        currentValRef.current = currentVal;
    }, [currentVal]);

    useEffect(() => {
        props.isOpenCanMakeChanges && props.onColourChanged && currentVal && currentVal !== props.colour && props.onColourChanged(currentVal);
    }, [currentVal]);
    useEffect(() => {
        console.log('ColourPickerContent isOpen changed:', props);
        if (props.onColourSelected && !props.isOpen) {
            confirmColourChange(true);
        }
        setEditMode(false);
        setBusy(false);
    }, [props.isOpen]);
    useEffect(() => {
        slideOutPanelControl.confirmColourChange = () => {
            confirmColourChange();
        };
    }, [props.onColourSelected]);
    useEffect(() => {
        if (isDraggingRef.current) return;
        if (props.colour) {
            const incomingHex = COLOUR_NAME_TO_COLOUR_HEX(props.colour, props.campaignData);
            const currentHex = COLOUR_NAME_TO_COLOUR_HEX(currentVal, props.campaignData);
            if (incomingHex !== currentHex) {
                setCurrentVal(COLOUR_HEX_TO_COLOUR_NAME(props.colour, props.campaignData) || props.colour);
            }
        }
    }, [props.colour]);

    useEffect(() => {
        slideOutPanelControl.panelState.canRefreshColourPicker = true;
        const onMouseUp = () => {
            isDraggingRef.current = false;
            slideOutPanelControl.panelState.canRefreshColourPicker = true;
        };
        document.body.addEventListener('mouseup', onMouseUp);
        return () => {
            isDraggingRef.current = false;
            slideOutPanelControl.panelState.canRefreshColourPicker = false;
            document.body.removeEventListener('mouseup', onMouseUp);
        }
    }, []);

    const confirmColourChange = (force = false) => {
        if ((props.onColourSelected && currentValRef.current && currentValRef.current !== props.colour) || force) {
            props.onColourSelected(currentValRef.current);
            UPDATE_RECENT_COLOURS(COLOUR_NAME_TO_COLOUR_HEX(currentValRef.current, props.campaignData), props.campaignData);
            setColourHasChangedNotApplied(false);
        }
    }

    const setVal = (newVal, confirm = false) => {
        const colourVal = COLOUR_NAME_TO_COLOUR_HEX(newVal, props.campaignData);
        console.log('Confirm colour val: ', newVal, colourVal);
        // Case-insensitive compare so lowercase-typed hex values are still recognised as hex colours
        const newValIsAColour = newVal.toUpperCase() === colourVal.toUpperCase() || newVal.toUpperCase() === colourVal.substring(1).toUpperCase();
        if (newValIsAColour) {
            if (newVal.substring(0, 1) !== '#') {
                newVal = '#' + newVal;
            }
            const foundColourName = COLOUR_HEX_TO_COLOUR_NAME(newVal, props.campaignData);
            if (foundColourName) {
                // We have a colour name, so we need to set the value to newVal (GET_COLOUR confirms this is valid)
                setCurrentVal(foundColourName);
                setColourHasChangedNotApplied(!confirm);
            } else {
                // We have a hex value, so we need to set the value to newVal (GET_COLOUR confirms this is valid)
                setCurrentVal(newVal);
                setColourHasChangedNotApplied(!confirm);
            }
        } else {
            // We are dealing with a colour name, so we need to set the value to newVal (GET_COLOUR confirms this is valid)
            // When confirming (ie. field loses focus, so we stopped typing), we want to replace alternatives that we accept with the proper colour name
            setCurrentVal(confirm ? COLOUR_HEX_TO_COLOUR_NAME(colourVal, props.campaignData) : newVal);
            setColourHasChangedNotApplied(!confirm);
        }
    }

    const [varLabel, setVarLabel] = useState(null);

    console.log('Rendering ColourPickerContent with props:', props);

    const [editMode, setEditMode] = useState(false);
    useEffect(() => {
        editMode ? slideOutPanelControl?.setOverridePanelTitle?.('Edit Color Pallette') : slideOutPanelControl?.setOverridePanelTitle?.(null);
    }, [editMode]);
    const [editingColourName, setEditingColourName] = useState(null);
    const [editingColourHex, setEditingColourHex] = useState(null);
    const [editingColourIndex, setEditingColourIndex] = useState(null);

    const enterEditMode = (colourName, colourHex, colourIndex) => {
        setEditMode(true);
        setEditingColourName(colourName);
        setEditingColourHex(colourHex);
        setEditingColourIndex(colourIndex);
    }

    const exitEditMode = () => {
        setEditMode(false);
        setBusy(false);
        setCurrentVal((val) => COLOUR_HEX_TO_COLOUR_NAME(val, props.campaignData) ? COLOUR_HEX_TO_COLOUR_NAME(val, props.campaignData) : val);
    }

    const handleEditModeClick = (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        if (IS_COLOUR_NAME(currentVal) && GET_COLOUR_INDEX_FROM_COLOUR_NAME(currentVal) !== undefined) {
            const colourHex = COLOUR_NAME_TO_COLOUR_HEX(currentVal, props.campaignData);
            const colourIndex = GET_COLOUR_INDEX_FROM_COLOUR_NAME(currentVal);
            enterEditMode(currentVal, colourHex, colourIndex);
        } else {
            enterEditMode('PRIMARY', props.campaignData.colours[0], 0);
        }
    }

    const addNewColour = (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        props.hideTooltipFunc();
        enterEditMode('COLOR' + (props.campaignData.colours.length + 1), currentVal, props.campaignData.colours.length);
    }

    console.log('Colour picker: ', editMode, currentVal);

    return (
        <>
            {editMode &&
                <EditColourPalletteContent
                    campaignData={props.campaignData}
                    colourName={editingColourName}
                    colourHex={editingColourHex}
                    colourIndex={editingColourIndex}
                    busy={busy}
                    setBusy={setBusy}
                    exitEditMode={exitEditMode}
                    showTooltipFunc={props.showTooltipFunc}
                    hideTooltipFunc={props.hideTooltipFunc}
                />
            }
            {!editMode && currentVal &&
                <div className="form-field-content-holder" onMouseDown={() => { isDraggingRef.current = true; slideOutPanelControl.panelState.canRefreshColourPicker = false; }} onMouseUp={() => { isDraggingRef.current = false; slideOutPanelControl.panelState.canRefreshColourPicker = true; }} onMouseLeave={(e) => { if (e.buttons === 0) { isDraggingRef.current = false; slideOutPanelControl.panelState.canRefreshColourPicker = true; } }}>
                    <div className="form-field-content">
                        {/* <h2>Choose Color</h2> */}
                        <div className="fl-row">

                            <div className="fl-column grow">
                                {varLabel &&
                                    <div className="var-label">{varLabel}</div>
                                }

                                <div className="fl-row grow">
                                    {/* <div className="grow"></div> */}
                                    <HexColorPicker color={COLOUR_NAME_TO_COLOUR_HEX(currentVal, props.campaignData)} onChange={setVal} />
                                    {/* <div className="grow"></div> */}
                                </div>
                                <hr />
                                <div className="colour-swatch-container">
                                    <div className="colour-swatch-row">
                                        <div className="v2-module-field-label">Hex Code</div>
                                        <div className="grow"></div>
                                    </div>

                                    <div className="colour-swatch-row">
                                        {/* <div className="grow"></div> */}

                                        <div className="current-color"
                                            style={{ background: COLOUR_NAME_TO_COLOUR_HEX(currentVal, props.campaignData)}}
                                            onMouseEnter={props.showTooltipFunc && IS_COLOUR_NAME(currentVal) ? (e) => props.showTooltipFunc(COLOUR_NAME_TO_COLOUR_HEX(currentVal, props.campaignData), e) : null}
                                            onMouseLeave={props.hideTooltipFunc}
                                        ></div>

                                        <FormField
                                            id={"colourPicker"}
                                            placeholder="#000000"
                                            showLabel={false}
                                            type="text"
                                            maxLength={12}
                                            setFunc={setVal}
                                            confirmChangeFunc={(val) => setVal(val, true)}
                                            value={currentVal}
                                            showError={false}
                                            className="c-hex-field"
                                        />

                                        <div className={`bottom-button${colourHasChangedNotApplied ? '' : ' disabled'}`} onClick={() => confirmColourChange(true)} style={{height: '2rem'}}>Apply</div>
                                        
                                    </div>
                                </div>
                                <hr />
                                <div className="colour-swatch-container">
                                    <div className="colour-swatch-row">
                                        <div className="v2-module-field-label">Recent Colors</div>
                                        <div className="grow"></div>
                                    </div>
                                    <div className="colour-swatch-row">
                                        {props.campaignData.recentColours.map((colour, index) => {
                                            if (!colour || colour === '') {
                                                return null;
                                            }
                                            return (
                                                <div key={index} className={`colour-swatch`}
                                                    style={{ background: colour }} onClick={(e) => setVal(COLOUR_HEX_TO_COLOUR_NAME(colour, props.campaignData) ?? colour)}
                                                    onMouseEnter={props.showTooltipFunc ? (e) => props.showTooltipFunc(`${COLOUR_HEX_TO_COLOUR_NAME(colour, props.campaignData) ? COLOUR_HEX_TO_COLOUR_NAME(colour, props.campaignData) + ': ' : ''}${colour}`, e) : null}
                                                    onMouseLeave={props.hideTooltipFunc}
                                                ></div>
                                            )
                                        })}
                                    </div>
                                </div>
                                <hr />
                                <div className="colour-swatch-container campaign-colours">
                                    {/*IconJsxer.GetIcon(IconJsxer.ICONS.edit, IconJsxer.ICON_STYLES.campaignPanelTop, 'edit-icon', handleEditModeClick)*/}
                                    <div className="colour-swatch-row">
                                        <div className="v2-module-field-label">Color Pallette</div>
                                        <div className="grow"></div>
                                        <div className="text-button" onClick={handleEditModeClick}>Edit</div>
                                    </div>
                                    <div className="colour-swatch-row">
                                        <div className={`colour-swatch${currentVal?.toLowerCase() === 'primary' ? ' selected' : ''}`}
                                            style={{ background: props.campaignData.colours[0] }} onClick={(e) => setVal('PRIMARY')}
                                            onMouseEnter={props.showTooltipFunc ? (e) => props.showTooltipFunc('PRIMARY: ' + COLOUR_NAME_TO_COLOUR_HEX('PRIMARY', props.campaignData), e) : null}
                                            onMouseLeave={props.hideTooltipFunc}
                                        ></div>
                                        <div className={`colour-swatch${currentVal?.toLowerCase() === 'secondary' ? ' selected' : ''}`}
                                            style={{ background: props.campaignData.colours[1] }} onClick={(e) => setVal('SECONDARY')}
                                            onMouseEnter={props.showTooltipFunc ? (e) => props.showTooltipFunc('SECONDARY: ' + COLOUR_NAME_TO_COLOUR_HEX('SECONDARY', props.campaignData), e) : null}
                                            onMouseLeave={props.hideTooltipFunc}
                                        ></div>
                                        <div className={`colour-swatch${currentVal?.toLowerCase() === 'tertiary' ? ' selected' : ''}`}
                                            style={{ background: props.campaignData.colours[2] }} onClick={(e) => setVal('TERTIARY')}
                                            onMouseEnter={props.showTooltipFunc ? (e) => props.showTooltipFunc('TERTIARY: ' + COLOUR_NAME_TO_COLOUR_HEX('TERTIARY', props.campaignData), e) : null}
                                            onMouseLeave={props.hideTooltipFunc}
                                        ></div>
                                    {/* </div>
                                    <div className="colour-swatch-row"> */}
                                        {props.campaignData.colours.length > 3 && props.campaignData.colours.slice(3).map((colour, index) => {
                                            return (
                                                <div key={index} className={`colour-swatch${currentVal?.toLowerCase() === 'color' + (index + 4) ? ' selected' : ''}`}
                                                    style={{ background: colour }} onClick={(e) => setVal('COLOR' + (index + 4))}
                                                    onMouseEnter={props.showTooltipFunc ? (e) => props.showTooltipFunc('COLOR' + (index + 4) + ': ' + colour, e) : null}
                                                    onMouseLeave={props.hideTooltipFunc}
                                                ></div>
                                            )
                                        })}
                                        {!IS_COLOUR_NAME(currentVal) && !busy &&
                                            <div className={`add-btn`}
                                                onClick={addNewColour}
                                                onMouseEnter={props.showTooltipFunc ? (e) => props.showTooltipFunc(`Save ${currentVal} To Campaign Colours`, e) : null}
                                                onMouseLeave={props.hideTooltipFunc}
                                            >
                                                {IconJsxer.GetIcon(IconJsxer.ICONS.plus, IconJsxer.ICON_STYLES.roundPanelButtonSmall)}
                                            </div>
                                        }
                                    </div>
                                </div>

                                {/* <button className="standard-button" onClick={confirmNewColor}>Submit</button> */}
                            </div>

                        </div>
                    </div>
                </div>
            }
        </>
    )
}
export default ColourPickerContent;
